// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseModal_closeButton__AHphu","fadeIn":"CloseModal_fadeIn__Ot6DO","iconShake":"CloseModal_iconShake__xvbWM"};